module.exports = __webpack_public_path__ + "static/media/banner-config.efa296ef.png";